import PropTypes from 'prop-types';
import React from 'react';

function DropDownItem ({ children }) {
    return <li role="menuitem">{ children }</li>;
}

DropDownItem.propTypes = { children: PropTypes.node.isRequired };

export default DropDownItem;
